import { TableOptions } from "react-table";

export const defaultTableInstanceConfig: Partial<TableOptions<any>> = {
  autoResetExpanded: false,
  disableMultiSort: true,
  autoResetSortBy: false,
};
